"use strict";

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var __spread = this && this.__spread || function () {
  for (var ar = [], i = 0; i < arguments.length; i++) {
    ar = ar.concat(__read(arguments[i]));
  }

  return ar;
};

exports.__esModule = true;
exports.match = exports.select = exports.not = exports.when = exports.__ = void 0;

var Pattern_1 = require("./types/Pattern");

exports.__ = Pattern_1.__;
exports.when = Pattern_1.when;
exports.not = Pattern_1.not;
exports.select = Pattern_1.select;
/**
 * ### match
 * Entry point to create pattern matching code branches. It returns an
 * empty Match case.
 */

exports.match = function (value) {
  return builder(value, []);
};
/**
 * ### builder
 * This is the implementation of our pattern matching, using the
 * builder pattern.
 * This builder pattern is neat because we can have complexe type checking
 * for each of the methods adding new behavior to our pattern matching.
 */


var builder = function builder(value, patterns) {
  return {
    "with": function _with(pattern) {
      var args = [];

      for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
      }

      var handler = args[args.length - 1];
      var predicates = args.slice(0, -1);

      var doesMatch = function doesMatch(value) {
        return Boolean(matchPattern(pattern)(value) && predicates.every(function (predicate) {
          return predicate(value);
        }));
      };

      return builder(value, __spread(patterns, [{
        test: doesMatch,
        handler: handler,
        select: selectWithPattern(pattern)
      }]));
    },
    when: function when(predicate, handler) {
      return builder(value, __spread(patterns, [{
        test: predicate,
        handler: handler,
        select: function select() {
          return {};
        }
      }]));
    },
    otherwise: function otherwise(handler) {
      return builder(value, __spread(patterns, [{
        test: matchPattern(Pattern_1.__),
        handler: handler,
        select: function select() {
          return {};
        }
      }])).run();
    },
    run: function run() {
      var entry = patterns.find(function (_a) {
        var test = _a.test;
        return test(value);
      });

      if (!entry) {
        throw new Error("Pattern matching error: no pattern matches value " + value);
      }

      return entry.handler(value, entry.select(value));
    }
  };
};

var isObject = function isObject(value) {
  return value && typeof value === 'object';
};

var isGuardPattern = function isGuardPattern(x) {
  var pattern = x;
  return pattern && pattern.__patternKind === Pattern_1.PatternType.Guard && typeof pattern.__when === 'function';
};

var isNotPattern = function isNotPattern(x) {
  var pattern = x;
  return pattern && pattern.__patternKind === Pattern_1.PatternType.Not;
};

var isSelectPattern = function isSelectPattern(x) {
  var pattern = x;
  return pattern && pattern.__patternKind === Pattern_1.PatternType.Select;
};

var isListPattern = function isListPattern(x) {
  return Array.isArray(x) && x.length === 1;
}; // tells us if the value matches a given pattern.


var matchPattern = function matchPattern(pattern) {
  return function (value) {
    if (pattern === Pattern_1.__ || isSelectPattern(pattern)) return true;
    if (pattern === Pattern_1.__.string) return typeof value === 'string';
    if (pattern === Pattern_1.__.boolean) return typeof value === 'boolean';

    if (pattern === Pattern_1.__.number) {
      return typeof value === 'number' && !Number.isNaN(value);
    }

    if (isGuardPattern(pattern)) return Boolean(pattern.__when(value));
    if (isNotPattern(pattern)) return !matchPattern(pattern.__pattern)(value);
    if (isListPattern(pattern) && Array.isArray(value)) return value.every(function (v) {
      return matchPattern(pattern[0])(v);
    });
    if (typeof pattern !== typeof value) return false;

    if (Array.isArray(pattern) && Array.isArray(value)) {
      return pattern.length === value.length ? pattern.every(function (subPattern, i) {
        return matchPattern(subPattern)(value[i]);
      }) : false;
    }

    if (value instanceof Map && pattern instanceof Map) {
      return __spread(pattern.keys()).every(function (key) {
        return matchPattern(pattern.get(key))(value.get(key));
      });
    }

    if (value instanceof Set && pattern instanceof Set) {
      var patternValues = __spread(pattern.values());

      var allValues_1 = __spread(value.values());

      return patternValues.length === 0 ? allValues_1.length === 0 : patternValues.length === 1 ? patternValues.every(function (subPattern) {
        return Object.values(Pattern_1.__).includes(subPattern) ? matchPattern([subPattern])(allValues_1) : value.has(subPattern);
      }) : patternValues.every(function (subPattern) {
        return value.has(subPattern);
      });
    }

    if (isObject(value) && isObject(pattern)) {
      return Object.keys(pattern).every(function (k) {
        // @ts-ignore
        return matchPattern(pattern[k])(value[k]);
      });
    }

    return value === pattern;
  };
};

var selectWithPattern = function selectWithPattern(pattern) {
  return function (value) {
    var _a;

    if (isSelectPattern(pattern)) return _a = {}, _a[pattern.__key] = value, _a;
    if (isListPattern(pattern) && Array.isArray(value)) return value.map(function (v) {
      return selectWithPattern(pattern[0])(v);
    }).reduce(function (acc, selections) {
      return Object.keys(selections).reduce(function (acc, key) {
        acc[key] = (acc[key] || []).concat([selections[key]]);
        return acc;
      }, acc);
    }, {});
    if (Array.isArray(pattern) && Array.isArray(value)) return pattern.length <= value.length ? pattern.reduce(function (acc, subPattern, i) {
      return Object.assign(acc, selectWithPattern(subPattern)(value[i]));
    }, {}) : {};
    if (isObject(pattern) && isObject(value)) return Object.keys(pattern).reduce(function (acc, k) {
      // @ts-ignore
      return Object.assign(acc, selectWithPattern(pattern[k])(value[k]));
    }, {});
    return {};
  };
};